<template>
  <div class="w-full pt-5">
    <template>
      <div class="flex items-center">
        <div class="border-r border-romanSilver h-6 flex">
          <BackButton label="Back" @onClick="$router.back()" variant="secondary" class="ml-2" />
        </div>
        <h1 class="text-xl text-left font-extrabold mx-4">
          {{ agreementData.title }}
        </h1>
        <Breadcrumb :items="breadcrumbs" />
      </div>
    </template>
    <template v-if="isLoading">
      <div class="mt-20 h-full">
        <Loader size="xxs" :loader-image="false" />
      </div>
    </template>

    <template v-else>

      <template>
        <div class="mx-5 mt-10">

          <Tab class="mt-6 mx-3" :tabs="tabsItems" :active-tab="activeTab" @currentTab="activateTab($event)"
            :border="true" />

          <StatusReportView v-if="activeTab === 'Status Report Overview'" :hideTab="true" />

          <template v-if="activeTab !== 'Status Report Overview'">

            <template>
              <div class="p-5 flex flex-col shadow my-5 rounded-md gap-4">
                <template>
                  <div class="flex justify-between items-center">
                    <span class="font-bold text-lg leading-5 tracking-normal capitalize text-darkPurple">
                      Appraisal Cycle - {{ agreementData.title }}
                    </span>
                  </div>
                </template>
                <div class="grid grid-cols-12 gap-7" style="margin-top: 1.125rem">
                  <div class="col-span-4 mt-1">
                    <c-text placeholder="--Enter--" variant="w-full" class=" mt-1" :disabled="true"
                      v-model="$route.params.year" label="Financial Year" />
                  </div>

                  <div class="col-span-4">
                    <c-text placeholder="--Enter--" variant="w-full" v-model="agreementData.template" class=" mt-1"
                      :disabled="true" label="Template" />
                  </div>

                  <div class="col-span-4">
                    <c-text placeholder="--Enter--" variant="w-full" class=" mt-1" :disabled="true"
                      v-model="agreementData.description" label="Description" />
                  </div>
                </div>
                <template>
                  <div class="border border-dashed bg-white border-romanSilver rounded-md gap-4 p-3 mt-4">
                    <div class="flex items-center w-full gap-2 cursor-pointer" @click="handleShowDetails">
                      <span
                        class="font-black text-xs leading-5 uppercase tracking-wider text-romanSilver whitespace-nowrap">
                        Performance Details
                      </span>

                      <div class="flex-grow border-t border-solid border-romanSilver h-0"></div>

                      <Icon :icon-name="showDetails ? 'chevronDown' : 'chevronRight'"
                        class-name="text-darkPurple self-center" size="xms" />
                    </div>

                    <div class="grid gap-2 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 mt-3"
                      :class="{ hidden: !showDetails }">
                      <div class="flex w-full p-3 shadow rounded-md gap-2">
                        <Icon size="s" icon-name="doc-cycle" class-name="text-romanSilver self-start pt-1" />
                        <div class="flex flex-col">
                          <span class="font-black text-xs leading-5 tracking-wide text-darkPurple uppercase">
                            {{ agreementData.cycle }}
                          </span>
                          <span class="font-bold text-sm leading-6 tracking-wide text-jet uppercase">
                            {{ agreementData.description }}
                          </span>
                        </div>
                      </div>

                      <div class="flex w-full p-3 shadow rounded-md gap-2">
                        <Icon size="xs" icon-name="calendar" class-name="text-romanSilver self-start pt-1" />
                        <div class="flex flex-col">
                          <span class="font-black text-xs leading-5 tracking-wide text-carrotOrange uppercase">
                            Period
                          </span>
                          <span class="font-bold text-sm leading-6 tracking-wide text-jet uppercase">
                            {{
                              $DATEFORMAT(new Date(agreementData.period.start), "MMMM dd, yyyy")
                            }}
                            -
                            {{
                              $DATEFORMAT(new Date(agreementData.period.end), "MMMM dd, yyyy")
                            }}
                          </span>
                        </div>
                      </div>
                      <!-- <PerformanceDetails :agreementCycles="agreementCycles" 
                        :isMyApraisal="true" :extendedCycle="extendedCycle"
                      /> -->
                      <div v-for="(cycle, index) in agreementCycles" :key="cycle.id"
                        class="flex w-full p-3 shadow rounded-md gap-2"
                        :class="cycle.active ? '' : 'opacity-40 cursor-not-allowed'"
                      >
                        <Icon size="xs" icon-name="reviewicon" class-name="text-romanSilver self-start pt-1" />
                        <div class="flex flex-col">
                            <span class="font-black text-xs leading-5 tracking-wide text-blueCrayola uppercase">
                            {{ cycle.name }}
                            </span>
                            <span class="font-bold text-sm flex leading-6 tracking-wide text-jet uppercase">
                            {{
                                $DATEFORMAT(new Date(cycle.start), "MMMM dd, yyyy")
                            }}
                            -
                            {{
                                $DATEFORMAT(new Date(cycle.end), "MMMM dd, yyyy")
                            }}
                            <span class="ml-4 flex" v-if="extendedCycle && extendedCycle.appraisalCycleId === cycle.id">
                                <p class="text-sm italic text-mediumSeaGreen uppercase" style="margin-top: 0.15rem">
                                Extended
                                </p>
                                <Icon icon-name="icon-info" size="xs" class="ml-3" style="margin-top: -0.15rem" />
                            </span>
                            </span>
                      </div> 
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>



            <div v-if="startAppraisal">


              <template>

                <div class="mt-20 h-full" v-if="loadingAppraisal">
                  <Loader size="xxs" :loader-image="false" />
                </div>


                <div class="my-3 px-2" v-else>
                  <div class="w-full flex flex-row justify-between" style="margin-top: 20px;">
                    <div class="flex h-auto mt-2">
                      <h1 class="text-base font-bold">KPAs</h1>
                    </div>

                    <div class="w-auto flex items-center gap-2">
                      <div class="w-auto flex cursor-pointer items-center" @click="getEachAgreementComments()">
                        <Icon icon-name="comment-plus-icon" style="color: white" size="xsm" />
                      </div>
                      <div class="h-4 mx-3 w-px bg-gray-400" />
                      <div class="flex items-center justify-between p-2 bg-ghostWhite rounded">
                        <span class="text-sm font-black whitespace-nowrap">
                          Total Allocated Weight:
                        </span>
                        <span class="text-sm text-desire ml-2">
                          {{ allocatedWeight }}%
                        </span>
                      </div>

                      <div class="self-stretch w-px bg-gray-400 mx-3"></div>

                      <div class="flex items-center justify-between p-2 bg-ghostWhite rounded">
                        <span class="text-sm font-semibold">
                          {{ appraisalApprovedScore ? appraisalApprovedScore : approvedScore || '---' }}
                        </span>
                      </div>

                    </div>
                  </div>


                  <div class="w-full h-px bg-gray-300 my-4"></div>

                  <!--- List of KPAs-->

                  <div class="w-full h-auto flex flex-col">
                    <ValidationObserver rules="required" v-slot="{ handleSubmit }">

                      <accordion class="mt-6" v-for="(kpaTypes, kpaNumber) in templateKPATypes"
                        :key="'kpa-' + kpaNumber" show-divider :is-open="true">
                        <template v-slot:title>
                          <span class="font-bold">{{ kpaTypes.name }}</span>
                        </template>

                        <template v-slot:block>
                          <div class="w-auto flex items-center">
                            <div class="w-auto flex items-center">
                              <Icon icon-name="comment-plus-icon" style="color: white" size="xsm" />
                            </div>

                            <div class="h-4 mx-2 w-px bg-gray-400" />

                            <div class="w-auto flex items-center">
                              <img
                                src="@/assets/images/hugeicons_assignments.svg"
                                style="width: 24px; height: 24px"
                              />
                            </div>

                            <div class="h-4 mx-2 w-px bg-gray-400" />

                            <div class="py-1 px-2 w-auto flex gap-2 items-center bg-gray-50 shadow-sm rounded-sm">
                              <span class="font-black text-xs">
                                {{ kpaTypes.weight }}%
                              </span>
                            </div>

                            <div class="h-4 mx-2 w-px bg-gray-400" />

                            <div class="p-2 w-auto flex gap-2 bg-gray-50 shadow-sm items-center rounded-sm mr-2">
                              <span class="font-black text-xs">
                                {{ kpaTypeScores[kpaTypes.id] || '---' }}
                              </span>
                            </div>

                            <div class="h-4 mx-2 w-px bg-gray-400" />

                            <div class="p-2 w-auto flex gap-2 bg-gray-50 shadow-sm items-center rounded-sm mr-2">
                              <span class="font-black text-xs">
                                {{
                                  kpaTotals[kpaTypes.name] === "" || kpaTotals[kpaTypes.name] == null
                                    ? "---"
                                    : kpaTotals[kpaTypes.name]
                                }}
                              </span>
                            </div>

                          </div>
                        </template>

                        <div class="flex flex-col w-full -mt-3">

                          <div class="w-full gap-6 flex flex-col">
                            <accordion class="px-5 bg-gray-50 shadow-md rounded-lg -mt-1 mb-0"
                              v-for="(item, index) in kpaTypes.kpas" :key="'kpi-' + index" :iconClass="'mt-2'"
                              :is-open="true">
                              <template v-slot:block>
                                <div class="w-full flex items-center mt-2 justify-between">

                                  <div class="w-auto flex">
                                    <div class="w-auto flex gap-2">
                                      <span class="font-bold text-flame text-sm">KPI :</span>
                                      <span class="font-semibold text-sm">{{ item.data?.name || item.name }}</span>
                                    </div>

                                    <div class="w-auto mx-4 flex gap-1">
                                      <span class="w-[1px] h-full border" />
                                    </div>

                                    <div class="w-auto flex gap-2">
                                      <span class="font-bold text-flame text-sm">Objective :</span>
                                      <span class="font-semibold text-sm">{{ item.data?.objective || item.objective
                                      }}</span>
                                    </div>
                                  </div>


                                  <div class="w-auto flex items-center">
                                    <div class="flex cursor-pointer items-center" @click="getEachAgreementComments(item.kpaId)">
                                      <Icon icon-name="comment-plus-icon" style="color: white" size="xsm" />
                                    </div>

                                    <div :class="'h-6'" class="w-auto mx-4 flex items-center">
                                      <span class="w-px bg-gray-300 h-6"></span>
                                    </div>

                                    <div class="flex cursor-pointer items-center"
                                      @click="viewReport(item, kpaTypes)">
                                      <img v-if="item.report === null || item.report === 'null'"
                                        src="@/assets/images/hugeicons_assignments-gray.svg"
                                        style="width: 24px; height: 24px"
                                      />
                                      <img v-else
                                        src="@/assets/images/hugeicons_assignments.svg"
                                        style="width: 24px; height: 24px"
                                      />
                                    </div>

                                    <div :class="'h-6'" class="w-auto mx-4 flex items-center">
                                      <span class="w-px bg-gray-300 h-6"></span>
                                    </div>
                                    <div
                                      class="px-2 py-1 w-auto flex gap-2 bg-white shadow-sm items-center rounded-sm mt-1">
                                      <span class="font-black text-xs">
                                        {{ item.data?.weight || item.weight }}%
                                      </span>
                                    </div>

                                    <div class="h-4 mx-2 w-px bg-gray-400" />

                                    <div
                                      class="p-2 w-auto flex gap-2 bg-gray-50 shadow-sm items-center rounded-sm mr-2">
                                      <span class="font-black text-xs">
                                        {{ getReviewType() === 'final_review' ? item.approvedScore :
                                          item.approvedFlag || '---' }}
                                      </span>
                                    </div>

                                  </div>

                                </div>
                              </template>

                              <div class="w-full h-[1px] mb-6 -mt-3 border border-2" />


                              <!-- Labels row -->
                              <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 w-full mb-3">
                                <!-- KPI Criteria List -->
                                <div class="flex flex-col" v-for="(n, rating) in (item.data?.kpis || item.kpis)"
                                  :key="rating">
                                  <span v-if="rating === 0" class="text-sm font-semibold mb-1">Criteria</span>
                                  <span v-else>&nbsp;</span>
                                  <c-text variant="w-full" class="mr-2 -mt-2" :disabled="true" :value="n.criteria" />
                                </div>

                                <!-- Employee Self Rating -->
                                <div class="flex flex-col w-full mt-6">
                                  <span class="text-sm font-semibold mb-3">Employee Self-Appraisal</span>
                                  <div class="w-full flex">
                                    <div class="w-full">
                                      <ValidationObserver rules="required">
                                        <div class="w-full flex flex-col gap-1">
                                          <div class="w-full flex bg-white -mt-2" v-if="
                                            startAppraisal && !isAppraisalLocked">
                                            <select @change="
                                              changeRating(
                                                $event,
                                                item,
                                                templateKPATypes,
                                                kpaTypes.id,
                                                getReviewType()
                                              )
                                              " @input="setInput(kpaTypes.name)" class="input-select"
                                              v-model="item.ratingId" :rules="['required']">
                                              <option value="" disabled selected>
                                                --Rating--
                                              </option>
                                              <option v-for="option in activeRatingOptions" :value="option.id"
                                                :key="option.id">
                                                {{ option.name }}
                                              </option>
                                            </select>
                                          </div>
                                          <c-select placeholder="--Rating--" variant="w-full" class="-ml-1 -mt-4"
                                            type="number" :disabled="true" :options="activeRatingOptions"
                                            v-model="item.ratingId" v-else />
                                        </div>
                                      </ValidationObserver>
                                    </div>
                                  </div>
                                </div>

                                <!-- Line Manager Rating -->
                                <div class="flex w-full flex-col mt-6">
                                  <span class="text-sm font-semibold mb-3">Direct Line Manager</span>
                                  <div class="w-full flex flex-col gap-1">
                                    <c-select placeholder="--Rating--" variant="w-full" class="w-full -mt-4"
                                      type="number" :disabled="true" :options="activeRatingOptions"
                                      v-model="item.managerRating" v-if="employee || isAppraisalLocked" />

                                    <div class="w-full flex bg-white -mt-2" v-else>
                                      <select @change="
                                        changeManagerRating(
                                          $event,
                                          item,
                                          templateKPATypes,
                                          kpaTypes.id,
                                          getReviewType()
                                        )
                                        " @input="setInput(kpaTypes.name)" class="input-select"
                                        v-model="item.managerRating">
                                        <option value="" disabled selected>
                                          --Rating--
                                        </option>
                                        <option v-for="option in activeRatingOptions" :value="option.id"
                                          :key="option.id">
                                          {{ option.name }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>


                                <!-- Dotted Line Manager Rating -->
                                <div class="flex w-full flex-col mt-6"
                                  v-if="hasDottedReporting && dottedReportingAppraisal">
                                  <span class="text-sm font-semibold mb-3">Dotted Line Manager</span>
                                  <div class="w-full flex bg-white">
                                    <c-select placeholder="--Rating--" variant="w-full" class="w-full -mt-4"
                                      type="number" :disabled="true" :options="activeRatingOptions"
                                      v-model="item.dottedLineManagerRating" v-if="employee || isAppraisalLocked" />

                                    <select @change="
                                      changeManagerRating(
                                        $event,
                                        item,
                                        templateKPATypes,
                                        kpaTypes.id,
                                        getReviewType()
                                      )
                                      " @input="setInput(kpaTypes.name)" class="mr-2 -ml-1 mt-1 w-full input-select"
                                      v-model="item.dottedLineManagerRating" v-else>
                                      <option value="" disabled selected>
                                        --Rating--
                                      </option>
                                      <option v-for="option in activeRatingOptions" :value="option.id" :key="option.id">
                                        {{ option.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>

                              </div>

                            </accordion>
                          </div>
                        </div>
                      </accordion>

                      <template>
                        <div class="flex -mt-4 items-center border-b border-gray-200 py-2">
                          <span class="text-sm font-bold text-gray-700 whitespace-nowrap">
                            FINAL SCORE
                          </span>

                          <div class="flex-1 h-px bg-gray-200 mx-4"></div>

                          <div class="flex items-center space-x-2">
                            <span class="px-3 py-3 text-sm font-semibold text-gray-600 bg-gray-100 rounded-md">
                              APPROVED SCORE <span class="font-bold text-darkPurple">
                                {{ appraisalApprovedScore ? appraisalApprovedScore : approvedScore || '---' }}
                              </span>
                            </span>
                            <span class="px-3 py-3 text-sm font-semibold text-gray-600 bg-gray-100 rounded-md">
                              SELF-APPRAISAL 
                              <span class="font-bold text-darkPurple">
                                <!-- {{ selfAppraisalScore ? selfAppraisalScore : totalSelfAppraisalScore}} -->
                                {{ showTotalAppraisalSelf ? totalSelfAppraisalScore : (selfAppraisalScore ? selfAppraisalScore : totalSelfAppraisalScore) }}
                              </span>
                            </span>
                          </div>
                        </div>
                      </template>

                      <template v-if="loaded">
                        <div class="w-full flex p-3 gap-4 justify-between items-center" v-if="!isAppraisalLocked">
                          <div class="flex justify-start gap-2">
                            <Button label="Share with Appraiser" variant="primary" @onClick="submitAppraiser('active')" />
                            <Button label="Save as Draft" variant="secondary btn-border"
                              @onClick="submitAppraiser('draft')" />
                            <Button label="Cancel" @onClick="$router.back()" class="button-class-secondary btn-border" />
                          </div>
                          <div class="w-5/12 flex mx-4 p-2 rounded-md bg-yellow-50 border border-yellow-500">
                            <Icon class-name="text-carrotOrange mx-auto self-center" size="xs" icon-name="icon-info" />
                            <span class="flex text-sm mx-3">
                              Once submitted, your manager(s) can now give their own
                              appraisals, and approve upon agreement.
                            </span>
                          </div>
                        </div>
                      </template>
                    </ValidationObserver>
                  </div>

                </div>

              </template>
            </div>

            <div class="w-full" v-if="appraisalMessage !== '' && !startAppraisal">
              <div class="w-full flex flex-col justify-center items-center mt-20">
                <icon icon-name="empty_agreement" size="l" style="width: 300px" />
                <div class="w-1/2 text-base text-center">
                  {{ appraisalMessage }}
                </div>
              </div>
            </div>

            <div class="fit-content flex mx-4 p-2 rounded-md bg-yellow-50 border border-yellow-500"
              v-if="appraisalMessage !== '' && startAppraisal && loaded">
              <Icon class-name="text-carrotOrange" size="xs" icon-name="icon-info" />
              <span class="flex text-sm mx-3">
                {{ appraisalMessage }}
              </span>
            </div>

          </template>
        </div>
      </template>
    </template>

    <template>
      <RightSideBar v-if="isOpenComments" @submit="sendComment" :disabled-button="isSavingComment"
        @close="isOpenComments = false, senderkpaId = '', comment = ''" button-class="bg-dynamicBackBtn text-white">
        <template v-slot:title>
          <p class="text-darkPurple font-bold text-lg leading-5 p-0">
            Comments
          </p>
        </template>
        <div class="w-full flex mb-7">
          <div class="flex flex-col w-full" style="min-height: 70vh">
            <CommentsBox :comments="allComments" :senderId="senderId" @markRead="markAsRead($event)"
              @deleteComment="deleteComments($event)" :loading="loadComments" />
            <div class="-mb-12" style="margin-top: auto">
              <CTextarea placeholder="--Message--" variant="primary" class="mt-2 rounded-lg" value="" :row="8"
                :height="90" :col="30" :input="null" v-model="comment" />
            </div>
          </div>
        </div>
      </RightSideBar>

      <RightSideBar v-if="statusModal" @close="statusModal = false"
        :submit="isAppraisalLocked ? '' : 'Save'"
        @submit="saveReport"
        button-class="bg-dynamicBackBtn text-white"
        :disabled-button="isSavingReport || isAppraisalLocked">
        <template v-slot:title>
          <div class="w-full flex justify-between items-center">
            <span class="text-darkPurple font-bold text-lg leading-5 p-0">Report New</span>
            <span class="text-blueCrayola font-bold text-sm uppercase cursor-pointer flex"
              @click="$router.push({ name: 'EssEmployeeStatusReports' })">
              <Icon icon-name="history-icon" class="text-blueCrayola" size="xms" />
              History
            </span>
          </div>
        </template>
        <StatusReport :kpasItem="kpasItem" :kpaTypes="kpaTypes" :edit="!isAppraisalLocked" @update-files="updateFiles"
          @update-comment="updateComment" @update-support="updateSupport" @update-status="updateStatus"
          @kpis-criteriaValues="kpisCriteriaValues"/>
      </RightSideBar>
    </template>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import BackButton from "@scelloo/cloudenly-ui/src/components/back-button";
import Tab from "@scelloo/cloudenly-ui/src/components/tab";
import Button from "@scelloo/cloudenly-ui/src/components/button";
import CText from "@scelloo/cloudenly-ui/src/components/text";
import CTextarea from "@scelloo/cloudenly-ui/src/components/text-area";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import Card from "@scelloo/cloudenly-ui/src/components/card";
import ScrollContainer from "@/components/ScrollContainer";
import Loader from "@/components/Loader";
import Accordion from "@/components/Accordion";
import Table from "@/components/Table";
import Icon from "@/components/Icon";
import RightSideBar from "@/components/RightSideBar";
import CommentsBox from "@/components/commentsBox";
import StatusReport from "@/components/StatusReport";
import paramsMixin from "@/utilities/paramsMixin";
import timeFormatMixin from "@/utilities/timeFormatMixin";
import StatusReportView from "./EmployeeStatusReport";
import PerformanceDetails from "@/components/PerformanceDetails";

export default {
  name: "PerformanceEmployeeAppraisals",
  mixins: [paramsMixin, timeFormatMixin],
  components: {
    ValidationObserver,
    Tab,
    Breadcrumb,
    StatusReport,
    StatusReportView,
    BackButton,
    Button,
    CSelect,
    CommentsBox,
    ScrollContainer,
    CText,
    Loader,
    Card,
    Accordion,
    Table,
    Icon,
    CTextarea,
    RightSideBar,
    PerformanceDetails
  },
  data() {
    return {
      kpaTypeSelfScores: {},
      kpaTotals: {},
      kpaTypeAvgSelfScores: {},
      openModal: false,
      statusModal: false,
      isLoading: true,
      loaded: false,
      loadingAppraisal: true,
      isOpenComments: false,
      loadComments: true,
      isManager: false,
      tabsItems: [],
      agreementData: {
        title: null,
        cycle: null,
        description: null,
        period: { start: null, end: null },
      },
      agreementCycles: [],
      activeTab: `${this.$route.params.cycle}`,
      KPAHeader: [
        { title: "KPA", value: "name" },
        { title: "Objective", value: "objective" },
        { title: "KPI", value: "kpis" },
        { title: "Weight (%)", value: "weight" },
      ],
      breadcrumbs: [
        {
          disabled: false,
          text: "Performance",
          href: "Performance",
          id: "Performance",
        },
        {
          disabled: false,
          text: "Performance Appraisals",
          href: "performance-appraisals",
          id: "PerformanceAppraisals",
        },
        {
          disabled: false,
          text: "Employee Appraisal",
          href: "employee-appraisal",
          id: "EmployeeAppraisal",
        },
      ],
      startAppraisal: false,
      appraisalStartDate: "",
      appraisalEndDate: "",
      appraisalMessage: "",
      appraisalEnd: false,
      allocatedWeight: 0,
      templateKPATypes: [],
      Ratings: [],
      ratingOptions: [],
      flagOptions: [],
      employeeAppraisals: [],
      selfAppraisalScore: null,
      lineManagerAppraisalScore: "",
      approvedScore: "",
      appraisalStatus: "",
      appraisalFlag: "",
      appraisalState: "",
      checkEditAppraisal: false,
      disableAppraisal: false,
      hasDottedReporting: false,
      dottedReportingAppraisal: false,
      midTermAppraisalStructure: '',
      appraisalDisplay: "",
      employee: false,
      finalAppraisal: false,
      cyclesArr: [],
      kpaAppraisalSummary: [],
      inputChange: [],
      allComments: [],
      showDetails: true,
      comment: "",
      totalSelfAppraisalScore: '---',
      payload: {
        employeeAgreementId: "",
        orgId: null,
        goalId: null,
        year: "",
        employeeId: "",
        appraisal_status: "",
        status: "draft",
        cycleId: "",
        appraisalFor: "",
        appraisalBy: "",
        share: false,
        reviewType: "",
        kpa_types: [],
      },
      extendedCycle: {},
      appraisalApprovedScore: null,
      senderkpaId: '',
      managerId: '',
      senderId: '',
      kpasItem: {},
      kpaTypes: {},
      files: [],
      reportComment: '',
      requireSupport: '',
      reportStatus: '',
      currentAchievement: '',
      criteriaValues: '',
      changeCount: 0,
      showTotalAppraisalSelf: false,
      isSavingComment: false,
      isSavingReport: false,
      appraisalLoadId: 0,
    };
  },

  watch: {
     totalSelfAppraisalScore(newVal, oldVal) {
      if (oldVal !== undefined && newVal !== oldVal) {
        this.changeCount++;
        if (this.changeCount >= 2) {
          this.showTotalAppraisalSelf = true;
        }
      }
    },
    activeTab: {
      async handler(newTab, oldTab) {
        if (!newTab || newTab === oldTab || newTab === "Status Report Overview") {
          return;
        }

        const cycle = this.cyclesArr.find((c) => c.name === newTab);
        // Cycles may not be ready on first paint — loadData handles the initial fetch.
        if (!cycle) {
          return;
        }

        const loadId = ++this.appraisalLoadId;
        this.resetAppraisalData();
        this.payload.cycleId = cycle.id;
        this.finalAppraisal = newTab === this.tabsItems[this.tabsItems.length - 2];
        this.payload.reviewType = this.finalAppraisal ? "final_review" : "mid_review";

        try {
          await this.getEmployeeAppraisal();
          if (loadId !== this.appraisalLoadId) return;
          await this.getAgreements(loadId);
        } catch (error) {
          console.error("Error loading appraisal tab:", error);
          if (loadId === this.appraisalLoadId) {
            this.loadingAppraisal = false;
            this.isLoading = false;
          }
        }
      }
    },

    templateKPATypes: {
      deep: true,
      immediate: true,
      async handler() {
        if (!this.templateKPATypes.length) {
          this.totalSelfAppraisalScore = '---';
          this.approvedScore = '---';
          return;
        }

        // 🔹 Calculate self score
        let totalSelf = 0;
        this.templateKPATypes.forEach(kpaType => {
          if (kpaType.kpas) {
            kpaType.kpas.forEach(item => {
              const self = parseFloat(item.selfScore);
              if (!isNaN(self)) {
                totalSelf += self;
              }
            });
          }
        });

        if (this.getReviewType() !== 'mid_review') {
          this.totalSelfAppraisalScore = totalSelf > 0 ? totalSelf.toFixed(2) : '---';
        } else {
          if(totalSelf.toFixed(2) > 0) {
          const average = await this.getAverageAppraisal(totalSelf.toFixed(2), '');
          this.totalSelfAppraisalScore = average || '---';
          }
          else {
          this.totalSelfAppraisalScore = '---';
          }
        }

        this.loadKPATotals();

        // 🔹 Calculate manager + dotted
        let totalManager = 0;
        let totalDotted = 0;

        this.templateKPATypes.forEach(kpaType => {
          if (kpaType.kpas) {
            kpaType.kpas.forEach(item => {
              const manager = parseFloat(item.managerScore);
              const dotted = parseFloat(item.dottedLineManagerScore);

              if (!isNaN(manager)) {
                totalManager += manager;
              }

              if (!isNaN(dotted)) {
                totalDotted += dotted;
              }
            });
          }
        });

        let finalScore;

        if (this.hasDottedReporting && this.dottedReportingAppraisal) {
          // dotted reporting enabled
          if (totalManager === 0 && totalDotted === 0) {
            finalScore = '---';
          } else {
            let avg;

            if (totalManager > 0 && totalDotted > 0) {
              avg = (totalManager + totalDotted) / 2;
            } else if (totalManager > 0) {
              avg = totalManager;
            } else if (totalDotted > 0) {
              avg = totalDotted;
            } else {
              avg = 0; // both are 0
            }

            if (this.getReviewType() === 'final_review') {
              finalScore = avg > 0 ? avg.toFixed(2) : '---';
            } else {
              const average = avg > 0 ? await this.getAverageAppraisal(avg.toFixed(2), '') : null;
              finalScore = average || '---';
            }
          }
        } else {
          // only manager scores
          if (totalManager === 0) {
            finalScore = '---';
          } else if (this.getReviewType() === 'final_review') {
            finalScore = totalManager > 0 ? totalManager.toFixed(2) : '---';
          } else {
            const average = await this.getAverageAppraisal(totalManager.toFixed(2), '');
            finalScore = average || '---';
          }
        }
        this.approvedScore = finalScore;
      }
    }
  },

  computed: {
    isAppraisalLocked() {
      return (
        this.appraisalState === "active" ||
        this.appraisalStatus === "submitted" ||
        this.appraisalEnd
      );
    },

    activeRatingOptions() {
      if (!this.finalAppraisal) {
        if (this.midTermAppraisalStructure === "regular_ratings") {
          return this.ratingOptions;
        }
        return this.flagOptions;
      }
      return this.ratingOptions;
    },

    kpaTypeScores() {
      const scores = {};
      this.templateKPATypes.forEach(kpaType => {
        if (!kpaType.kpas) {
          scores[kpaType.id] = '---';
          return;
        }
        // Check if any KPA has null selfScore
        if (kpaType.kpas.some(item => item.selfScore == null)) {
          scores[kpaType.id] = '---';
          return;
        }

        const totalScore = kpaType.kpas.reduce((sum, item) => {
          return sum + (parseFloat(item.selfScore) || 0);
        }, 0);

        const totalWeight = kpaType.kpas.reduce((sum, item) => {
          return sum + (parseFloat(item.weight) || 0);
        }, 0);

        if (this.getReviewType() !== 'mid_review') {
          scores[kpaType.id] = totalScore.toFixed(2);
        } else {
        
          const weightedScore = (totalScore / totalWeight) * 100;
          this.calculateAndCacheScore(weightedScore, kpaType.id);
          // For mid_review, use cached value or calculate
          if (this.kpaTypeSelfScores[kpaType.id] !== undefined) {
            scores[kpaType.id] = this.kpaTypeSelfScores[kpaType.id];
          } else {
            // const weightedScore = (totalScore / totalWeight) * 100;
            // Trigger async calculation but return placeholder
            // this.calculateAndCacheScore(weightedScore, kpaType.id);
            scores[kpaType.id] = '---';
          }
        }
      });
      return scores;
    },
  },

  methods: {
    getKPIFlag(ratingId, flagOptions) {
      return flagOptions.find(flag => flag.id === ratingId)?.name || '---';
    },
    getReviewType() {
      if (!this.finalAppraisal) {
        if (this.midTermAppraisalStructure === "regular_ratings") {
          return 'final_review';
        }
        return 'mid_review';
      }
      return 'final_review';
    },

    handleShowDetails() {
      this.showDetails = !this.showDetails;
    },

    async activateTab(tab) {
      if (tab === this.activeTab) return;

      this.finalAppraisal = tab === this.tabsItems[this.tabsItems.length - 2];
      this.payload.reviewType = this.finalAppraisal ? "final_review" : "mid_review";

      const cycle = this.cyclesArr.find((c) => c.name === tab);
      if (cycle) this.payload.cycleId = cycle.id;

      const cycleMeta = this.agreementCycles.find((c) => c.name === tab);
      if (cycleMeta?.appraisal_starts && cycleMeta?.appraisal_ends) {
        this.checkAppraisalStart(
          cycleMeta.appraisal_starts,
          cycleMeta.appraisal_ends
        );
      }

      // Watcher loads appraisal data when activeTab changes.
      this.activeTab = tab;
    },

    // async activateTab(tab) {
    //   if (tab === 'Status Overview') return;

    //   this.inputChange = [];
    //   this.finalAppraisal = tab === this.tabsItems[this.tabsItems.length - 2];
    //   this.payload.reviewType = this.finalAppraisal ? "final_review" : "mid_review";

    //   const cycle = this.cyclesArr.find(c => c.name === tab);
    //   if (cycle) this.payload.cycleId = cycle.id;

    //   this.resetAppraisalData();

    //   try {
    //     const response = await this.$_getAppraisalCycle(this.appraisalQuery());
    //     const appraisal = response.data.AppraisalCycle;

    //     appraisal[0].cycles.forEach(cycle => {
    //       if (cycle.name === this.activeTab) {
    //         this.checkAppraisalStart(cycle.appraisal_starts, cycle.appraisal_ends);
    //       }
    //     });

    //     this.activeTab = tab;
    //   } catch (error) {
    //     console.error("Error activating tab:", error);
    //   }
    // },

    formatCommentTime(date) {
      const newDate = new Date(date);
      const hours = newDate.getUTCHours();
      const minutes = newDate.getMinutes();
      return `${1 + ((hours - 1) % 12)}:${minutes.toString().padStart(2, "0")} ${hours > 11 ? "PM" : "AM"}`;
    },

    formatCommentDate(date) {
      return new Date(date).toDateString();
    },

    setInput(kpaTypeName) {
      if (!this.inputChange.includes(kpaTypeName)) {
        this.inputChange.push(kpaTypeName);
      }
    },
    async changeRating(event, item, kpaTypes, kpaTypeId, reviewType) {
      await this.updateScore(event.target.value, item, kpaTypes, kpaTypeId, reviewType, 'self');
    },
    async changeManagerRating(event, item, kpaTypes, kpaTypeId, reviewType) {
      await this.updateScore(event.target.value, item, kpaTypes, kpaTypeId, reviewType, 'manager');
    },

    async updateScore(ratingId, item, kpaTypes, kpaTypeId, reviewType, scoreType) {
      try {
        const response = await this.$_calculateRatingScore(item.kpaId, ratingId, reviewType);
        const { score } = response.data.data;

        // Update the item score first
        if (reviewType === "mid_review") {
          item[`${scoreType}Score`] = score;
          item[`${scoreType}Rating`] = response.data.data.rank.flag.name;
        } else {
          item[`${scoreType}Score`] = score;
          item[`${scoreType}Rating`] = score;
        }

        // Force recomputation of the computed property by clearing cache
        // and triggering reactive update
        this.$delete(this.kpaTypeSelfScores, kpaTypeId);

        // If you need to immediately recalculate, do it here
        this.recalculateKPAScore(kpaTypes, kpaTypeId);

      } catch (error) {
        console.error("Error updating score:", error);
      }
    },

    recalculateKPAScore(kpaTypes, kpaTypeId) {
      const kpaType = kpaTypes.find(type => type.id === kpaTypeId);
      if (!kpaType || !kpaType.kpas) return;

      const totalScore = kpaType.kpas.reduce((sum, item) => {
        return sum + (parseFloat(item.selfScore) || 0);
      }, 0);

      const totalWeight = kpaType.kpas.reduce((sum, item) => {
        return sum + (parseFloat(item.weight) || 0);
      }, 0);

      if (this.getReviewType() === 'mid_review') {
        const weightedScore = (totalScore / totalWeight) * 100;
        this.calculateAndCacheScore(weightedScore, kpaTypeId);
      }
    },

    async calculateAndCacheScore(weightedScore, kpaTypeId) {
      try {
        const flag = await this.getAverageAppraisal(weightedScore, kpaTypeId);
        this.$set(this.kpaTypeSelfScores, kpaTypeId, flag || '---');
      } catch (error) {
        console.error("Error calculating score:", error);
        this.$set(this.kpaTypeSelfScores, kpaTypeId, '---');
      }
    },

    calculateScores(kpaTypes, kpaTypeId, scoreType) {
      let sum = 0;
      let totalWeight = 0;
      let totalSum = 0;

      kpaTypes.forEach(type => {
        if (type.id === kpaTypeId) {
          type.kpas.forEach(item => {
            sum += item[`${scoreType}Score`] || 0;
            totalWeight += item.weight || 0;
          });
        }

        type.kpas.forEach(item => {
          totalSum += item[`${scoreType}Score`] || 0;
        });
      });

      const weightedScore = (sum / totalWeight) * 100;
      return { weightedScore: weightedScore.toFixed(2), totalSum };
    },

    async getAverageAppraisal(score, id) {
      try {
        const { data } = await this.$_getScoreAppraisalFlag(score);

        // ✅ Safely check for nested properties
        if (data && data.ranking && data.ranking.flag && data.ranking.flag.name) {
          return data.ranking.flag.name;
        }
        return "---"; // fallback value
      } catch (error) {
        return "---"; // fallback in case of error
      }
    },

    getAverageSummary() {
      /* const appraisalSummary = this.employeeAppraisals.flatMap(appraisal =>
        appraisal.summary.filter(el => el.employeeFlag).map(el => el.kpaTypeName)
      );

      if (appraisalSummary.includes(kpaTypeName) && !this.inputChange.includes(kpaTypeName)) {
        this.kpaAppraisalSummary = [];
        const { summary, score } = this.getKPATotalSelfAppraisal(kpaTypeName);
        return score ? `${summary} (${score})` : summary;
      }

      const kpa = this.kpaAppraisalSummary.find(k => k.id === id);
      return kpa ? (kpa.score ? `${kpa.summary} (${kpa.score})` : kpa.summary) : '---'; */
    },

    getKPATotalScore(kpaId, kpaTypes) {
      if (kpaTypes.id !== kpaId) return "";

      const sum = kpaTypes.kpas.reduce((total, item) => total + (item.selfScore || 0), 0);
      return sum >= 0 ? sum.toFixed(2) : "";
    },
    getKPATotalManagerScore(kpaId, kpaTypes) {
      if (kpaTypes.id !== kpaId) return "";

      const sum = kpaTypes.kpas.reduce((total, item) => total + (item.managerScore || 0), 0);
      return sum >= 0 ? sum.toFixed(2) : "";
    },
    getKPATotalManagerAppraisal(kpaTypesname) {
      const result = { summary: null, score: null };

      this.employeeAppraisals.forEach(appraisal => {
        if (appraisal.cycle === this.activeTab) {
          appraisal.summary.forEach(summary => {
            if (summary.kpaTypeName === kpaTypesname) {
              result.summary = summary.managerFlag || '---';
              result.score = summary.managerKpaTypeScore || '---';
            }
          });
        }
      });

      return result.summary ?
        (result.score ? `${result.summary} (${result.score})` : result.summary) :
        (result.score ? `(${result.score})` : '---');
    },


    getKPATotalSelfAppraisal(reviewType) {
      let total = 0;

      this.templateKPATypes.forEach(category => {
        category.kpas.forEach(kpa => {
          if (kpa.selfScore !== null && !isNaN(kpa.selfScore)) {
            total += kpa.selfScore;
          }
        });
      });

      if (reviewType === 'mid_review') {
        // console.log(this.flagOptions);
        // console.log(total)
      }
      return total.toFixed(2);
    },


    async loadKPATotals() {
      const results = await Promise.all(
        this.templateKPATypes.map(kpaType => this.getKPATotalApprovedAppraisal(kpaType.name))
      );
     
      this.templateKPATypes.forEach((kpaType, idx) => {
        this.$set(this.kpaTotals, kpaType.name, results[idx]);
      });
    },

    async getKPATotalApprovedAppraisal(kpaTypesname) {
      const appraisals = this.employeeAppraisals.filter(appraisal => appraisal.cycle === this.activeTab);
      const result = { summary: null, score: null };

      // Flatten all summaries for the active cycle
      const summaries = appraisals.flatMap(appraisal => appraisal.summary);

      // Find the summary for the given kpaTypesname
      const foundSummary = summaries.find(summary => summary.kpaTypeName === kpaTypesname);

      if (foundSummary) {
        if (this.hasDottedReporting && this.dottedReportingAppraisal) {
          let avgScore;

          const managerScore = foundSummary.managerKpaTypeScore !== null ? Number(foundSummary.managerKpaTypeScore) : null;
          const dottedScore = foundSummary.dottedManagerKPATypeScore !== null ? Number(foundSummary.dottedManagerKPATypeScore) : null;

          if (managerScore !== null && dottedScore !== null) {
            avgScore = (managerScore + dottedScore) / 2;
          } else if (managerScore !== null) {
            avgScore = managerScore;
          } else if (dottedScore !== null) {
            avgScore = dottedScore;
          } else {
            avgScore = null;
          }

          if (avgScore !== null) {
            const data = await this.getAverageAppraisal(avgScore.toFixed(2), '');
            result.summary = data || '---';
            result.score = avgScore.toFixed(2);
          } else {
            result.summary = '---';
            result.score = '---';
          }
        } else {
          result.summary = foundSummary.managerFlag || '---';
          result.score = foundSummary.managerKpaTypeScore || '---';
        }
      }

      return this.getReviewType() === 'final_review'
        ? (result.score != null && result.score !== 'NaN' && !isNaN(Number(result.score))
          ? Number(result.score).toFixed(2)
          : '---')
        : result.summary;
    },


    async submitAppraiser(state) {
      if (this.isAppraisalLocked) {
        this.$toasted.error("This appraisal can no longer be edited", { duration: 5000 });
        return;
      }

      this.payload.orgId = this.$orgId;
      this.payload.appraisal_status = "pending";
      this.payload.year = this.$route.params.year;
      this.payload.status = state === "draft" ? "draft" : "active";
      this.payload.share = state !== "draft";
      this.payload.appraisalFor = this.$AuthUser.id;
      this.payload.appraisalBy = this.$AuthUser.id;

      const kpaData = this.prepareKPAData();


      if (state === "active") {
        const isValid = this.validateKPAs(kpaData);

        if (!isValid) {
          this.$toasted.error("No scores set for each KPA", { duration: 5000 });
          return;
        }
      }

      this.payload.kpa_types = kpaData;

      try {
        const response = await this.$_setEmployeeAppraisal(this.payload);
        this.$toasted.success(response.data.message, { duration: 5000 });
        this.$router.push({
          name: "EssAppraisals",
          query: { activeTab: "My Appraisals" },
        });
      } catch (error) {
        this.$toasted.error(error.response.data.message, { duration: 5000 });
      }
    },

    prepareKPAData() {
      return this.templateKPATypes.map(kpaType => ({
        kpa_types_id: kpaType.id,
        kpas: kpaType.kpas.map(({ name, objective, kpis, weight, outcome, selfRating, selfScore, managerRating, managerScore, ...rest }) => rest)
      }));
    },
    validateKPAs(kpaData) {
      return kpaData.every(type =>
        type.kpas.every(item => item.ratingId)
      );
    },
    resetAppraisalData() {
      this.employeeAppraisals = [];
      this.templateKPATypes = [];
      this.loaded = false;
      this.loadingAppraisal = true;
      this.startAppraisal = false;
      this.appraisalMessage = "";
      this.appraisalEnd = false;
      this.selfAppraisalScore = null;
      this.totalSelfAppraisalScore = '';
      this.lineManagerAppraisalScore = "";
      this.approvedScore = "";
      this.appraisalStatus = "";
      this.appraisalState = "";
    },

    getCriteriaData(kpis) {
      if (!Array.isArray(kpis) || !kpis.length || !this.Ratings?.length) {
        return [];
      }

      const criteriaData = [];
      const sortedRatings = [...this.Ratings].sort((a, b) => a.rating - b.rating);
      const sortedKPIS = [...kpis].sort(
        (a, b) => (a.score?.rating || 0) - (b.score?.rating || 0)
      );
      this.Ratings = sortedRatings;

      sortedRatings.forEach((rating, index) => {
        const kpi = sortedKPIS[index];
        if (!kpi) return;
        criteriaData.push({
          id: kpi.id,
          performanceRatingId: rating.id,
          criteria: kpi.criteria,
        });
      });
      return criteriaData;
    },

    getAppraisalCycle() {
      this.tabsItems = [];
      this.cyclesArr = [];
      this.agreementCycles = [];
      const today = new Date();

      return this.$_getAppraisalCycle(this.appraisalQuery()).then((response) => {
        const appraisal = response.data.AppraisalCycle;
        const { extension } = response.data;
        this.extendedCycle = extension;

        const appraisalCycle = appraisal[0].cycles.sort(
          (a, b) => this.setDates(a.appraisal_starts) - this.setDates(b.appraisal_starts)
        );

        this.payload.cycleId = appraisalCycle[0].id;

        appraisalCycle.forEach((cycle) => {
          this.tabsItems.push(cycle.name);

          const cycleStartDate = new Date(this.setDates(cycle.appraisal_starts).toISOString());
          const cycleEndDate = new Date(this.setDates(cycle.appraisal_ends).toISOString());
          cycleEndDate.setDate(cycleEndDate.getDate() + 1);
          
          this.agreementCycles.push({
            name: cycle.name,
            start: this.setDates(cycle.appraisal_starts).toISOString(),
            end: this.setDates(cycle.appraisal_ends).toISOString(),
            appraisal_starts: cycle.appraisal_starts,
            appraisal_ends: cycle.appraisal_ends,
            active: today >= cycleStartDate && today <= cycleEndDate,
            id: cycle.id,
          });
          
          this.cyclesArr.push({
            id: cycle.id,
            name: cycle.name,
          });
        });
        this.tabsItems.push('Status Report Overview');

        if(this.tabsItems.length <= 2) {
          this.finalAppraisal = true
        }

        // Call checkAppraisalStart once after all cycles are processed
        const activeCycle = appraisalCycle.find(c => c.name === this.activeTab);
        if (activeCycle) {
          this.checkAppraisalStart(activeCycle.appraisal_starts, activeCycle.appraisal_ends);
          this.payload.cycleId = activeCycle.id;
          this.finalAppraisal = this.activeTab === this.tabsItems[this.tabsItems.length - 2];
          this.payload.reviewType = this.finalAppraisal ? "final_review" : "mid_review";
        }
      });
    },

    async getSettings() {
      const response = await this.$_getPerformanceGeneralSetting();
      if (response.data.PerformanceSettings.length > 0) {
        this.checkEditAppraisal = response.data.PerformanceSettings[0].managerCanEditEmployeeAppraisal;
        this.dottedReportingAppraisal = response.data.PerformanceSettings[0].appraisalReviewer.includes('dotted_line_managers');
        this.midTermAppraisalStructure = response.data.PerformanceSettings[0].midTermAppraisalMethod;
      }
    },

    async getAppraisalFlags() {
      const response = await this.$_getAppraisalFlag();
      const { flags } = response.data;
      this.flagOptions = flags.map((flag) => ({
        id: flag.id,
        name: flag.name,
      }));
    },

    async getPerfomanceRating() {
      const response = await this.$_getPerfomanceRating();
      this.Ratings = response.data.PerformanceRatings;
      this.ratingOptions = response.data.PerformanceRatings.map((ratings) => ({
        id: ratings.id,
        name: ratings.rating,
      }));
    },


    checkAppraisalStart(startDate, endDate) {
      const today = new Date();
      const appraisalStartDate = this.setDates(startDate);
      const appraisalEndDate = this.setDates(endDate);
      appraisalEndDate.setDate(appraisalEndDate.getDate());

      this.appraisalStartDate = appraisalStartDate.toISOString();
      this.appraisalEndDate = this.setDates(endDate).toISOString();

      if (today >= appraisalStartDate && today <= appraisalEndDate) {
        this.startAppraisal = true;
      } else if (today < appraisalStartDate && today <= appraisalEndDate) {
        this.startAppraisal = false;
        this.appraisalMessage = `${this.activeTab} appraisal starts on the ${this.$DATEFORMAT(
          new Date(this.appraisalStartDate), "MMMM dd, yyyy"
        )}. You will be notified when it begins.`;
      } else {
        this.startAppraisal = true;
        this.appraisalMessage = `${this.activeTab} appraisal ended on the ${this.$DATEFORMAT(
          new Date(this.appraisalEndDate), "MMMM dd, yyyy"
        )}.`;
        this.appraisalEnd = true;
      }
    },

    async getEmployeeAppraisal() {
      try {
        const result = await this.$_getEmployeeAppraisal(this.$AuthUser.id);
        const responseData = result.data.EmployeeAppraisal;

        this.employeeAppraisals = [];
        this.selfAppraisalScore = null;
        this.lineManagerAppraisalScore = "";
        this.approvedScore = "";
        this.appraisalStatus = "";
        this.appraisalState = "";

        responseData.forEach((response) => {
          if (response.appraisal.current_cycle &&
            response.appraisal.current_cycle.name === this.activeTab) {

            this.payload.appraisalId = response.appraisal.id;
            this.appraisalApprovedScore = this.getReviewType() !== 'mid_review'  ? response.appraisal.approved_score : response.appraisal.appraisalRank?.flag.name;
            // if()
            if (this.finalAppraisal ) {
              this.selfAppraisalScore = response.appraisal.self_score;
            } else {
              this.selfAppraisalScore = this.getReviewType() === 'mid_review' ?
                `${response.appraisalSummary.employeeFlag}` : `${response.appraisalSummary.employeeFlagScore}`;
            }
            this.appraisalStatus = response.appraisal.appraisal_status;
            this.appraisalState = response.appraisal.appraisal_state;

            response.appraisal.performance_scores.forEach((score) => {
              this.employeeAppraisals.push({
                cycle: response.appraisal.current_cycle.name,
                id: score.kpaId,
                selfRatingPoint: score.selfRatingPoint,
                flagId: score.ranking ? score.ranking.flag.name : "",
                managerFlag: score.manager_ranking ? score.manager_ranking.flag.name : "",
                dottedManagerFlag: score.dotted_line_manager_ranking ? score.dotted_line_manager_ranking.flag.name : "",
                selfScore: score.selfScore,
                outcome: score.outcome,
                managerRatingPoint: score.managerRatingPoint,
                managerScore: score.managerScore,
                dottedManagerRatingPoint: score.dottedLineManagerRatingPoint,
                dottedManagerScore: score.dottedLineManagerScore,
                summary: response.summary,
              });

              if (this.finalAppraisal) {
                this.getAverageAppraisal(score.selfScore, score.kpaTypeId);
              }
            });
          } else {
            delete this.payload.appraisalId;
          }
        });
      } catch (error) {
        console.error("Error getting employee appraisal:", error);
      }
    },


    async getAgreements(loadId = null) {
      const currentLoadId = loadId ?? ++this.appraisalLoadId;
      this.loadingAppraisal = true;

      try {
        const response = await this.$_getEmployeeAgreement(this.$AuthUser.id);
        if (currentLoadId !== this.appraisalLoadId) return;

        const myAgreements = response.data.EmployeePerformanceAgreements || [];
        this.managerId = response.data.employee?.lineManager?.id || "";

        if (myAgreements.length === 0) {
          return;
        }

        // Find the agreement for the current year
        const agreement = myAgreements.find(
          (a) => Number(a.year) === Number(this.$route.params.year)
        );

        if (!agreement) {
          return;
        }

        // Process the agreement
        const agreementKPA = agreement.employee_agreement_kpa || [];

        this.agreementData.title = agreement.performance_template.title;
        this.agreementData.description = agreement.description;
        this.agreementData.cycle = agreement.performance_template.title;
        this.agreementData.period.start = this.setDates(
          agreement.performance_template.appraisal_cycle.cycle_start_date
        ).toISOString();
        this.agreementData.period.end = this.setDates(
          agreement.performance_template.appraisal_cycle.cycle_end_date
        ).toISOString();

        this.payload.employeeAgreementId = agreement.id;
        this.payload.goalId = this.$route.params.goalId;

        // Get template data
        const result = await this.$_getOneTemplate(agreement.templateId);
        if (currentLoadId !== this.appraisalLoadId) return;

        this.agreementData.template = result.data.PerformanceTemplate.title;
        this.templateKPATypes = result.data.PerformanceTemplate.kpa_types;

        let totalWeight = 0;

        for (const kpaType of this.templateKPATypes) {
          kpaType.kpas = [];

          for (const employeeKpi of agreementKPA) {
            if (employeeKpi.kpaTypeId === kpaType.id) {
              totalWeight += employeeKpi.weight || 0;

              kpaType.kpas.push({
                name: employeeKpi.name,
                objective: employeeKpi.objective,
                kpaId: employeeKpi.id,
                kpis: this.getCriteriaData(employeeKpi.kpis_employee),
                weight: employeeKpi.weight,
                outcome: this.getOutcome(employeeKpi.id),
                selfRating: this.getSelfRating(employeeKpi.id),
                selfScore: this.getScore(employeeKpi.id),
                ratingId: this.getRatingId(employeeKpi.id),
                managerRating: this.getManagerRatingId(employeeKpi.id),
                managerScore: this.getManagerScore(employeeKpi.id),
                approvedScore: await this.getApprovedScore(employeeKpi.id),
                approvedFlag: await this.getApprovedFlag(employeeKpi.id),
                ...(this.dottedReportingAppraisal &&
                  this.hasDottedReporting && {
                    dottedLineManagerRating: this.getDottedManagerRatingId(
                      employeeKpi.id
                    ),
                    dottedLineManagerScore: this.getDottedManagerScore(
                      employeeKpi.id
                    ),
                  }),
                report: employeeKpi.report,
              });
            }
          }

          kpaType.selfSummary = null;
        }

        if (currentLoadId !== this.appraisalLoadId) return;
        this.allocatedWeight = totalWeight;
      } catch (err) {
        console.error("Error processing agreement:", err);
      } finally {
        if (currentLoadId === this.appraisalLoadId) {
          this.loaded = true;
          this.loadingAppraisal = false;
          this.isLoading = false;
        }
      }
    },


    async getApprovedScore(kpasid) {
      const appraisal = this.employeeAppraisals.find(
        (a) => a.id === kpasid && a.cycle === this.activeTab
      );

      if (!appraisal) return '---';

      const hasManager = appraisal.managerScore != null;
      const hasDotted = appraisal.dottedManagerScore != null;

      if (!hasManager && !hasDotted) return '---';

      const managerScore = hasManager ? Number(appraisal.managerScore) : null;
      const dottedScore = hasDotted ? Number(appraisal.dottedManagerScore) : null;

      let score;

      if (this.hasDottedReporting) {
        if (hasManager && hasDotted) {
          score = (managerScore + dottedScore) / 2;
        } else {
          score = hasManager ? managerScore : dottedScore;
        }
      } else {
        score = hasManager ? managerScore : dottedScore;
      }

      return isNaN(score) ? '---' : score.toFixed(2);
    },



    async getApprovedFlag(kpasid) {
      const appraisal = this.employeeAppraisals.find(
        (a) => a.id === kpasid && a.cycle === this.activeTab
      );
      if (
        !appraisal ||
        (appraisal.managerScore == null && appraisal.dottedManagerScore == null)
      ) {
        return null; // or '---'
      }
      const scores = [];
      if (appraisal.managerScore != null) {
         scores.push(Number(appraisal.managerRatingPoint));
      }
      if (appraisal.dottedManagerScore != null) {
        scores.push(Number(appraisal.dottedManagerScore));
      }
      const score =
        scores.length > 1
          ? (scores[0] + scores[1]) / 2 // average if both exist
          : scores[0]

      if (score === null || isNaN(score)) {
        return '---'; // or null, depending on what you want as fallback
      }
      const { data } = await this.$_getScoreAppraisalFlag(score.toFixed(2));
      return data.ranking?.flag.name;
    },

    getScore(kpasid) {
      let score;
      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          score = appraisal.selfScore;
        }
        return {};
      });
      return score || '---';
    },

    getSelfRating(kpasId) {
      let result;

      this.employeeAppraisals.find((appraisal) => {
        if (appraisal.id === kpasId && appraisal.cycle === this.activeTab) {
          if (this.finalAppraisal || this.midTermAppraisalStructure === "regular_ratings") {
            result = appraisal.selfRatingPoint;
          } else {
            result = appraisal.flagId;
          }
          return true; // Stop iteration once found
        }
        return false;
      });

      return result;
    },

    getRatingId(kpasid) {
      let ratePoint;
      let rating;

      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          if (this.finalAppraisal || this.midTermAppraisalStructure === "regular_ratings") {
            ratePoint = appraisal.selfRatingPoint;
          } else {
            ratePoint = appraisal.flagId;
          }
        }
        return {};
      });

      if (ratePoint == null || ratePoint === "") {
        return "";
      }

      // decide based on midTermAppraisalStructure
      const options =
        this.finalAppraisal || this.midTermAppraisalStructure === "regular_ratings"
          ? this.ratingOptions
          : this.flagOptions;

      const matched = options.find(
        (option) => String(option.name) === String(ratePoint)
      );
      rating = matched?.id;

      return rating || "";
    },

    getOutcome(kpasid) {
      let outcome;
      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          outcome = appraisal.outcome;
        }
        return {};
      });
      return outcome || "";
    },

    getManagerRatingId(kpasid) {
      let ratePoint;
      let rating;

      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          if (this.finalAppraisal) {
            ratePoint = appraisal.managerRatingPoint;
            return
          } 
          if (this.midTermAppraisalStructure === "regular_ratings") {
            ratePoint = appraisal.managerRatingPoint;
          } else {
            ratePoint = appraisal.managerFlag;
          }
        }
      });

      if (ratePoint == null || ratePoint === "") {
        return "";
      }

      const options =
        this.finalAppraisal || this.midTermAppraisalStructure === "regular_ratings"
          ? this.ratingOptions
          : this.flagOptions;

      const matched = options.find(
        (option) => String(option.name) === String(ratePoint)
      );
      rating = matched?.id;

      return rating || "";
    },

    getManagerScore(kpasid) {
      let score;
      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          score = appraisal.managerScore;
        }
        return {};
      });
      return score || null;
    },


    getDottedManagerRatingId(kpasid) {
      let ratePoint;
      let rating;

      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          if (this.finalAppraisal) {
            ratePoint = appraisal.dottedManagerRatingPoint;
            return;
          } 
          if (this.midTermAppraisalStructure === "regular_ratings") {
            ratePoint = appraisal.dottedManagerRatingPoint;
          } else {
            ratePoint = appraisal.dottedManagerFlag;
          }
        }
      });

      if (ratePoint == null || ratePoint === "") {
        return "";
      }

      const options =
        this.finalAppraisal || this.midTermAppraisalStructure === "regular_ratings"
          ? this.ratingOptions
          : this.flagOptions;

      const matched = options.find(
        (option) => String(option.name) === String(ratePoint)
      );
      rating = matched?.id;

      return rating || "";
    },

    getDottedManagerScore(kpasid) {
      let score;
      this.employeeAppraisals.filter((appraisal) => {
        if (appraisal.id === kpasid && appraisal.cycle === this.activeTab) {
          score = appraisal.dottedManagerScore;
        }
        return {};
      });
      return score || null;
    },


    getUser() {
      return this.$_getUser(this.$AuthUser.id).then((result) => {
        this.loadingData = false;
        this.payload.employeeId = result.data.user.id;
        this.hasDottedReporting = result.data.user.userDesignation.dottedReportingTo ? true : false;
        if (result.data.user.userDesignation.reportingTo !== null) {
          this.employee = true;
        } else {
          this.employee = false;
        }
        // this.getSettings();
      });
    },

    async loadData() {
      const loadId = ++this.appraisalLoadId;
      this.isLoading = true;
      this.loadingAppraisal = true;

      try {
        await Promise.all([
          this.getSettings(),
          this.getAppraisalCycle(),
          this.getPerfomanceRating(),
          this.getUser(),
          this.getAppraisalFlags(),
        ]);

        if (loadId !== this.appraisalLoadId) return;

        await this.getEmployeeAppraisal();
        if (loadId !== this.appraisalLoadId) return;

        await this.getAgreements(loadId);
      } catch (error) {
        console.error("Error loading appraisal page:", error);
        if (loadId === this.appraisalLoadId) {
          this.loadingAppraisal = false;
          this.isLoading = false;
        }
      }
    },
    async getEachAgreementComments(kpiId = ''){
      this.senderkpaId = kpiId;
      const kpi = kpiId ? `?kpiId=${kpiId}` : '';
      this.loadComments = true;
      try {
        const { data } = await this.$_getEachAgreementComments(this.payload.employeeAgreementId, kpi);
        this.allComments = data.comments;
        this.isOpenComments = true;
        this.loadComments = false;
      } catch (error) {
        this.loadComments = false;
        this.senderkpaId = '';
        this.$toasted.error('Error getting comments', { duration: 5000 });
      }
    },
    async sendComment(){
      this.isSavingComment = true;
      const payload = {
        comment: this.comment,
        senderId: this.senderId, // userId of sender
        receiverId: this.managerId, // userId of receiver
        sendTo: "manager",
        performanceAgreementId: this.payload.employeeAgreementId,
        ...(this.senderkpaId && { kpiId: this.senderkpaId })
      }

      try {
        await this.$_sendAgreementComments(payload);
        this.allComments = [];
        this.comment = '';
        this.isOpenComments = false;
        this.isSavingComment = false;
        this.$toasted.success('Comment successfully sent', { duration: 5000 });
      } catch (error) {
        this.isSavingComment = false;
        this.$toasted.error('Error sending comment', { duration: 5000 });
      }
    },
    updateFiles(files){
      this.files= files
    },
    updateSupport(support){
      this.requireSupport = support
    },
    updateComment(comment){
      this.reportComment = comment
    },
    updateStatus(status){
      this.reportStatus = status
    },
    kpisCriteriaValues(criteriaValues){
      this.criteriaValues = criteriaValues;
    },
    async saveReport(){
      if (this.isAppraisalLocked) {
        this.$toasted.error("This appraisal can no longer be edited", { duration: 5000 });
        return;
      }
      this.isSavingReport = true;
      const payload = {
        orgId: this.$orgId,
        employeeId: this.senderId,
        employeeAgreementId: this.payload.employeeAgreementId,
        kpaTypeId: this.kpaTypes.id,
        kpiId: this.kpasItem.kpaId,
        status: this.reportStatus,
        criteria: this.criteriaValues,
        currentAchievement: '',
        requireSupport: this.requireSupport === "yes" ? true : false,
        comment: this.reportComment,
        files: this.files,
        ...(this.kpasItem.report && this.kpasItem.report !== 'null' && { reportId: this.kpasItem.report.id })
      }
      try {
        await this.$_saveReport(payload);
        await this.getEmployeeAppraisal();
        await this.getAgreements();
        this.statusModal = false;
        this.isSavingReport = false;
        this.$toasted.success('Report done successfully', { duration: 5000 });
      } catch (error) {
        this.isSavingReport = false;
        this.$toasted.error(error.response.data.message, { duration: 5000 });
      }
    },
    async viewReport(kpasItem, kpaTypes){
      this.statusModal = true;
      this.kpasItem = kpasItem;
      this.kpaTypes = kpaTypes;
    }
  },

  async mounted() {
    this.senderId = this.$AuthUser.id;
    await this.loadData();
  }
};
</script>


<style>
.fit-content {
  width: fit-content;
}

.input-select:disabled {
  background: #eeeeee;
  color: #878e99;
  border: none;
  background-image: none;
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 12px;
}

.input-select {
  border: 1px solid #878e99;
  height: 38px;
  padding: 10px 15px;
  width: 100%;
  border-radius: 5px;
  color: #321c3b;
  line-height: 120%;
  letter-spacing: 0.015em;
}

.input-select:focus {
  outline: none;
}

.input-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background-image: url(/img/down-arrow.f3bc3f05.svg);
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 14px;
  padding: 3px 15px;
  width: 100%;
  padding-right: 29px;
  outline: none;
  border: 1px solid #878e99;
  box-sizing: border-box;
  border-radius: 3px;
  height: 40px;
  /* width: 100%; */
  /* width: fit-content; */
}

.button_class {
  padding: 10px 40px !important;
  font-weight: 600;
  display: flex;
  justify-self: end;
}

.button-class-pimary {
  font-weight: 600 !important;
  font-size: 16px !important;
  padding: 10px 40px !important;
}

.button-class-secondary {
  color: #321c3b !important;
  background: white !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  padding: 10px 40px !important;
}

.btn-bg {
  background-color: var(--dynamic-Background) !important;
}

.btn-border {
  color: var(--dynamic-Background) !important;
  border: 1px solid var(--dynamic-Background);
}
</style>
